import React from "react";

import { ColumnProps } from "src/common/components/DataTable";
import { MobileColumnProps } from "src/common/components/MobileTable/types";

export function useFlatColumns(props: MobileColumnProps): ColumnProps[] {
	return React.useMemo(() => {
		const out: ColumnProps[] = [];
		if (props.icon !== undefined) {
			out.push(props.icon);
		}
		out.push(props.title);
		if (props.subtitle !== undefined) {
			out.push(props.subtitle);
		}
		out.push(...props.fix);
		out.push(...props.optional);
		return out;
	}, [props]);
}
